import { useMemo, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Activity } from "lucide-react";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import PasswordInput from "../components/common/PasswordInput";
import { APP_NAME } from "../config/branding";
import { erpApi } from "../services/erpApi";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const initialToken = useMemo(() => searchParams.get("token") || "", [searchParams]);
  const [form, setForm] = useState({ token: initialToken, password: "", confirmPassword: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    if (!form.token || !form.password) {
      toast.error("Token and new password are required");
      return;
    }
    if (form.password !== form.confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }
    setLoading(true);
    try {
      await erpApi.resetPassword({ token: form.token, password: form.password });
      toast.success("Password reset successfully. Please sign in.");
      navigate("/login");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to reset password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-hospital-bg p-4">
      <Card className="w-full max-w-md border border-gray-200 shadow-sm">
        <CardContent className="p-8">
          <div className="mb-8 flex items-center gap-3">
            <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-hospital-primary text-white">
              <Activity className="h-7 w-7" />
            </div>
            <div>
              <h1 className="font-manrope text-xl font-bold">{APP_NAME}</h1>
              <p className="text-sm text-hospital-text-muted">Reset password</p>
            </div>
          </div>
          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-2">
              <Label>Reset Token</Label>
              <Input value={form.token} onChange={(e) => setForm({ ...form, token: e.target.value })} />
            </div>
            <div className="space-y-2">
              <Label>New Password</Label>
              <PasswordInput autoComplete="new-password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
            </div>
            <div className="space-y-2">
              <Label>Confirm Password</Label>
              <PasswordInput autoComplete="new-password" value={form.confirmPassword} onChange={(e) => setForm({ ...form, confirmPassword: e.target.value })} />
            </div>
            <Button className="btn-primary w-full" disabled={loading}>
              {loading ? "Resetting..." : "Reset Password"}
            </Button>
            <Link to="/login" className="block text-center text-sm font-medium text-hospital-primary">
              Back to sign in
            </Link>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
